<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title><span translate>Eliminar contactos</span></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="step == 1">
  <ion-progress-bar type="indeterminate" *ngIf="isLoading == true"></ion-progress-bar>
  <ion-grid fixed>
    <ion-row fixed>
      <ion-col size="12">
        <h3>1.- Selecciona a los representantes</h3>
      </ion-col>
    </ion-row>
    <ion-row fixed>
      <ion-col size="12">
        <ion-button fill="solid" expand="block" color="primary" (click)="filter3()" [disabled]="isLoading">
          <ion-icon name="briefcase" slot="start"></ion-icon>
          Empresa / Laboratorio
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-searchbar
          placeholder="Búsqueda general"
          [debounce]="750"
          (ionChange)="getStringSearch($event)"
          (ionCancel)="clearSearch()"
          (ionClear)="clearSearch()"
        ></ion-searchbar>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-button
          shape="round"
          color="primary"
          size="small"
          *ngFor="let item of filterData2; let i = index"
          (click)="removeFilter2(i)"
        >
          {{ item.label }}
          <ion-icon slot="end" name="close"></ion-icon>
        </ion-button>
        <ion-button
          shape="round"
          color="primary"
          size="small"
          *ngFor="let item of filterData1; let i = index"
          (click)="removeFilter1(i)"
        >
          {{ item.label }}
          <ion-icon slot="end" name="close"></ion-icon>
        </ion-button>
        <ion-button
          shape="round"
          color="primary"
          size="small"
          *ngFor="let item of filterData3; let i = index"
          (click)="removeFilter3(i)"
        >
          {{ item.label }}
          <ion-icon slot="end" name="close"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="posts">
      <ion-col size="12" size-md="6" size-lg="4" *ngFor="let item of members; let i = index">
        <ion-card>
          <app-user-card
            [color]="item.color"
            [index]="i + 1"
            [item]="item"
            (click)="selectUser(item.id); item.color = item.color == 'primary' ? '' : 'primary'"
          >
          </app-user-card>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-infinite-scroll threshold="100px" (ionInfinite)="loadData($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando..."> </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
<ion-footer *ngIf="step == 1">
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-button expand="full" color="tertiary" [disabled]="!representantes[0] || isLoading" (click)="step1()">
          Continuar
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>

<ion-content *ngIf="step == 2">
  <ion-grid fixed>
    <ion-row fixed>
      <ion-col size="12">
        <h3>2.- Eliminar por</h3>
        <ion-list>
          <ion-radio-group value="specialty" [(ngModel)]="allocationType">
            <ion-item>
              <ion-label>Especialidad</ion-label>
              <ion-radio slot="start" value="specialty"></ion-radio>
            </ion-item>
            <ion-item>
              <ion-label>Zona geográfica</ion-label>
              <ion-radio slot="start" value="geographical-area"></ion-radio>
            </ion-item>
            <ion-item>
              <ion-label>Email</ion-label>
              <ion-radio slot="start" value="email"></ion-radio>
            </ion-item>
          </ion-radio-group>
        </ion-list>
      </ion-col>
      <ion-col>
        <ion-button
          expand="full"
          color="tertiary"
          [disabled]="!representantes[0] || !allocationType || isLoading"
          (click)="step2()"
        >
          Continuar
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-content *ngIf="step == 3">
  <ion-progress-bar type="indeterminate" *ngIf="isLoading == true"></ion-progress-bar>
  <ion-grid fixed>
    <ion-row fixed>
      <ion-col size="12">
        <div *ngIf="!(allocationType === 'email') && allocationType === 'geographical-area'">
          <h3>3.- Seleciona zona geográfica(s)</h3>
        </div>
        <div *ngIf="!(allocationType === 'email') && allocationType === 'specialty'">
          <h3>3.- Seleciona especialidad(s)</h3>
        </div>
        <div *ngIf="allocationType === 'email'">
          <h3>3.- Ingresa los emails de los usuarios para comenzar a eliminar las conexiónes</h3>
          <form (ngSubmit)="onSubmit()" [formGroup]="myForm" novalidate>
            <ion-list>
              <ion-item lines="inset">
                <ion-label color="medium" position="stacked" translate>Emails de los usuarios </ion-label>
                <ion-textarea
                  formControlName="ids"
                  autocomplete="ids"
                  rows="15"
                  placeholder="Los Emails deben estar separados comas o por saltos de línea."
                >
                </ion-textarea>
              </ion-item>
              <ion-text color="danger" [hidden]="myForm.controls.ids.valid || myForm.controls.ids.untouched">
                <span class="ion-padding" translate>Campo emails de los usuarios requerido</span>
              </ion-text>
            </ion-list>
            <div class="ion-padding-horizontal">
              <ion-button
                type="submit"
                [disabled]="myForm.invalid || isLoading"
                color="tertiary"
                expand="block"
                translate
              >
                Continuar
              </ion-button>
            </div>
          </form>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!(allocationType === 'email') && allocationType === 'geographical-area'">
      <ion-col size="12">
        <div *ngFor="let item of estadosObj; let i = index">
          <ion-card (click)="item.isChecked = !item.isChecked">
            <ion-item [color]="item.isChecked == true ? 'primary' : ''" lines="none" detail="true">
              <ion-label>
                <h2>
                  {{ item && item.title && item.title !== '' ? item.title : '(Sin zona geográfica)' }}
                </h2>
              </ion-label>
            </ion-item>
          </ion-card>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!(allocationType === 'email') && allocationType === 'specialty'">
      <ion-col size="12">
        <div *ngFor="let item of especialidadesObj; let i = index">
          <ion-card (click)="item.isChecked = !item.isChecked">
            <ion-item [color]="item.isChecked == true ? 'primary' : ''" lines="none" detail="true">
              <ion-label>
                <h2>
                  {{ item && item.title && item.title !== '' ? item.title : '(Sin especialidad)' }}
                </h2>
              </ion-label>
            </ion-item>
          </ion-card>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-infinite-scroll threshold="100px" (ionInfinite)="loadData2($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando..."> </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>

<ion-footer *ngIf="step == 3 && allocationType === 'geographical-area'">
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-button expand="full" color="tertiary" [disabled]="isLoading || !proofEstados()" (click)="step3_1()">
          Continuar
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
<ion-footer *ngIf="step == 3 && allocationType === 'specialty'">
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-button expand="full" color="tertiary" [disabled]="isLoading || !proofEspecialidades()" (click)="step3_2()">
          Continuar
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>

<ion-content *ngIf="step == 4">
  <ion-grid fixed>
    <ion-row>
      <ion-col size="12" size-md="6" size-lg="4" *ngFor="let item of allUniqueMedicosToDelete; let i = index">
        <ion-card>
          <app-user-card
            [color]="item.color"
            [index]="i + 1"
            [item]="item"
            (click)="selectUserLast(item); item.color = item.color == 'primary' ? '' : 'primary'"
          >
          </app-user-card>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer *ngIf="step == 4">
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-button
          expand="full"
          color="tertiary"
          [disabled]="isLoading || !uniqueMedicosToDelete[0]"
          (click)="filterLastMedicos()"
        >
          Continuar
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>

<ion-content *ngIf="step == 5">
  <ion-grid fixed>
    <ion-row fixed>
      <ion-col size="12">
        <h3>4.- Confirmar para continuar</h3>
        <p>Se eliminarán {{ allMedicosToDelete.length }} conexiónes, ¿Desea continuar?</p>
        <ion-button
          expand="full"
          color="tertiary"
          [disabled]="!allMedicosToDelete[0] || isLoading"
          (click)="initConn()"
        >
          Continuar
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-content *ngIf="step == 6">
  <ion-grid fixed>
    <ion-row fixed>
      <ion-col size="12">
        <h3>Resumen</h3>
        <p>Conexiónes eliminadas: {{ conexionesEliminadas.length }}</p>
        <p>Conexiónes no eliminadas: {{ conexionesNoEliminadas.length }}</p>
        <div *ngIf="notAcceptedUsers?.length > 0">
          <ion-text color="primary">
            <h4>No se pudo establecer conexión con éstos médicos:</h4>
          </ion-text>
          <ion-text color="primary" *ngFor="let doctor of notAcceptedUsers">
            <p>
              Médico: {{ doctor.name }} Email: {{ doctor.email }} ID: {{ doctor.id }} Especialidad(s):
              {{ doctor.especialidad1 }} {{ doctor.especialidad2 }} Estado(s): {{ doctor.estado1 }}
              {{ doctor.estado2 }}
            </p>
          </ion-text>
        </div>
        <ion-button expand="full" color="tertiary" [disabled]="isLoading" [routerDirection]="'root'" routerLink="/home">
          Terminar
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
